<template>
    <div class="row">
        <div class="col-md-12" v-if="Object.keys(request).length">
            <div class="row">
                <div :class="request.flowStepStatusId != 190 && request.flowStepStatusId != 191 ? 'col-md-9' : 'col-md-12'">
                    <div class="card mb-3">
                        <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات درخواست</div>
                        <div class="card-body">
                            <Loading v-if="showLoading" />
                            <div class="table-responsive">
                                <table class="table table-bordered table-hover mb-0 order-table-details">
                                    <tbody>
                                        <tr>
                                            <td>شناسه درخواست:</td>
                                            <td>{{ $route.params.id }}</td>
                                            <td>سازمان درخواست دهنده:</td>
                                            <td>{{ request.customerName }}</td>
                                            <td>مبلغ:</td>
                                            <td>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(request.amount) }} ریال</td>
                                        </tr>
                                        <tr style="border-left: 1px #000">
                                            <td>وضعیت:</td>
                                            <td colspan="3">{{ request.flowStepStatusTitle }}</td>
                                            <td>تاریخ</td>
                                            <td>{{ request.createdAt }}</td>
                                        </tr>
                                        <tr v-if="request.description" style="border-left: 1px solid #262644">
                                            <td>دلیل عدم تایید:</td>
                                            <td colspan="5">{{ request.description }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3" v-if="request.walletRrn || request.walletTrac">
                        <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات پرداخت</div>
                        <div class="card-body">
                            <Loading v-if="showLoading" />
                            <div class="table-responsive">
                                <table class="table table-bordered table-hover mb-0 order-table-details">
                                    <tbody>
                                        <tr>
                                            <td>شناسه ارجاع:</td>
                                            <td>{{ request.walletRrn || '-' }}</td>
                                            <td>شناسه پرداخت:</td>
                                            <td>{{ request.walletTrac || '-' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3" v-if="request.flowStepStatusId != 190 && request.flowStepStatusId != 191">
                    <div class="card mb-3">
                        <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">تغییر وضعیت</div>
                        <div class="card-body">
                            <Loading v-if="showLoading" />
                            <form @submit.prevent="submitForm">
                                <div class="form-group">
                                    <label>وضعیت</label>
                                    <select class="form-control custom-select" v-model="status">
                                        <option value="-1" selected disabled>انتخاب کنید</option>
                                        <option value="1">تایید</option>
                                        <option value="0">عدم تایید</option>
                                    </select>
                                </div>
                                <div class="form-group" v-if="status == 0">
                                    <label>توضیحات</label>
                                    <textarea rows="4" class="form-control" v-model="description"></textarea>
                                </div>
                                <button class="btn btn-success btn-block" :disabled="status == -1 || (status == 0 && !description)">ثبت اطلاعات</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12" v-else>
            <div class="card mb-3">
                <div class="card-body">
                    <div class="alert alert-info">
                        <p class="mb-0">داده ای یافت نشد</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Single',
    data(){
        return {
            request: {},
            status: -1,
            showLoading: true,
            description: ''
        }
    },
    methods: {
        getData(){
            this.$api.get('Organizations/Wallet/CashBack/GetAll').then(({data}) => {
                if(data.status){
                    let req = data.result.filter(req => req.requestId == this.$route.params.id);
                    if(req.length)
                        this.request = req[0];
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        submitForm(){
            this.showLoading = true;
            const postedData = {
                requestId: parseInt(this.$route.params.id),
                description: this.description || '',
                approv: this.status == 1 ? true : false
            };
            this.$api.post('Organizations/Wallet/CashBack/ChangeStatus',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'عملیات مورد نظر با موفقیت انجام شد'
                    });
                    this.$router.push({name: 'cashback'});
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>